// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"6a854ec8","453":"b53e255c"}[chunkId] + ".chunk.js";
};